import { Injectable } from '@angular/core';
import { Subject, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ConfirmDialogComponent } from 'src/app/dialogs/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LanguageService } from '../languageService/language.service';
import { DeviceService } from '../deviceService/device.service';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  onInvalidToken = new Subject();
  onUnauthorized = new Subject();
  onInvalidPin = new Subject();
  constructor(private http: HttpClient, private dialog: MatDialog, private deviceService: DeviceService, private languageService: LanguageService) { }

  // Sent Local GET Request
  localGetRequest(params) {
    var reqHeader = new HttpHeaders();

    return new Promise(resolve => {
      this.http.get<any>(params.url, { headers: reqHeader, withCredentials: true }).subscribe(data => {
        this.checkResponse(resolve, params, data, null);
      }, error => {
        this.checkResponse(resolve, params, error.error, error);
      })
    });
  };

  // Sent GET Request
  mainGetRequest(params) {
    var reqHeader = new HttpHeaders();

    reqHeader = reqHeader.append('X-DeviceAlias', this.deviceService.getDeviceAlias().alias);

    // Add Bearer Token every time except if excludeToken is true
    if (!params.excludeToken) {
      reqHeader = reqHeader.append('X-Jwt', localStorage.getItem("appT"));
    }

    return new Promise(resolve => {
      this.http.get<any>(environment.apiUrl + params.url, { headers: reqHeader, withCredentials: true }).subscribe(data => {
        this.checkResponse(resolve, params, data, null);
      }, error => {
        this.checkResponse(resolve, params, error.error, error);
      })
    });
  };

  // Sent POST Request
  mainPostRequest(params) {
    var reqHeader = new HttpHeaders();

    reqHeader = reqHeader.append('X-DeviceAlias', this.deviceService.getDeviceAlias().alias);

    // Add Bearer Token every time except if excludeToken is true
    if (!params.excludeToken) {
      reqHeader = reqHeader.append('X-Jwt', localStorage.getItem("appT"));
    }

    return new Promise(resolve => {
      this.http.post<any>(environment.apiUrl + params.url, params.req, { headers: reqHeader, withCredentials: true }).subscribe(data => {
        this.checkResponse(resolve, params, data, null);
      }, error => {
        this.checkResponse(resolve, params, error.error, error);
      })
    });
  };

  checkResponse(resolve, params, data, error) {
    if (this.checkError(params.url, data, error)) {
      this.hideLoader();
      return throwError(data);
    } else {
      resolve(data);
    }
  }

  //Handle HTTP & Server Errors
  handleError(error) {
    if (error.error instanceof ErrorEvent) {
      this.languageService.openSnackBar(`Error: ${error.error.message}`, {});
    } else if (error.status && error.status != 200) {
      this.languageService.openSnackBar("Status: " + error.status + ` Error: ${error.message}`, {});
    }
    this.hideLoader();
    return throwError(error);
  };

  //Check Error in order to decide how to handle them
  checkError(api, resp, error) {
    if (resp && resp.success == false) {
      //Ignore cases
      switch (api) {
        case "/api/auth/info":
        case "/api/auth/activate":
          return false;
          break;
        case "/api/auth/login":
        case "/api/apps/getTerminalParams":
          if (resp.message == "Token is expired" || resp.message == "Token is invalid") {
            return false;
          }
          break;
      };

      //Handling cases
      if (resp.errorCode == "Unauthorized" || resp.errorCode == "PasswordChanged" || resp.errorCode == "EmailChanged") {
        this.onUnauthorized.next();
      }
      if (resp.message == "Token is expired" || resp.message == "Token is invalid") {
        this.onInvalidToken.next();
      }
      if (resp.errorCode == "InvalidPin") {
        this.onInvalidPin.next();
        return true;
      } else if (resp.errorCode == "MaxDevicesExceed") {
        this.deviceService.getDevices(this);
        return true;
      }

      this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: "gen_error",
          message: resp?.errorCode,
          confirm: "gen_ok",
        },
        autoFocus: false,
        panelClass: "confirm-dialog"
      }).afterClosed().subscribe(resp => {

      });

      return true;
    } else if (resp && resp.success) {
      return false;
    } else {
      console.dir(error);
      this.handleError(error);
    }
  };

  //Hide Loader
  hideLoader() {
    document.getElementById("loader") ? document.getElementById("loader").style.display = "none" : null;
  };
}